const MAIL_TEMPLATE_PATH = window.location.origin + '/mail-template.html'

export type GenerateMailParams = {
  applicationName?: string | null
  description?: string | null
  logotypeUrl?: string | null
  title?: string | null
  head?: string | null
  body?: string | null
  info?: string | null
  summary?: string | null
  primaryColor: string | null
  primaryContrastColor: string | null
  primaryTextColor: string | null
  footer?: string | null
}

export const generateMail = async (params: GenerateMailParams) => {
  let template = await fetch(MAIL_TEMPLATE_PATH).then((response) => response.text())
  template = template.replace(/%LOGOTYPE_URL%/g, params.logotypeUrl ?? '')
  template = template.replace(/%TITLE%/g, params.title ?? '')
  template = template.replace(/%HEAD%/g, params.head ?? '')
  template = template.replace(/%BODY%/g, params.body ?? '')
  template = template.replace(/%INFO%/g, params.info ?? '')
  template = template.replace(/%SUMMARY%/g, params.summary ?? '')
  template = template.replace(/%PRIMARY_COLOR%/g, params.primaryColor ?? '')
  template = template.replace(/%PRIMARY_CONTRAST_COLOR%/g, params.primaryContrastColor ?? '')
  template = template.replace(/%PRIMARY_TEXT_COLOR%/g, params.primaryTextColor ?? '')
  template = template.replace(/%FOOTER%/g, params.footer ?? '')
  template = template.replace(/%APPLICATION_NAME%/g, params.applicationName ?? '')
  template = template.replace(/%DESCRIPTION%/g, params.description ?? '')
  return template
}
